/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import {AESVG} from "../../../_emywork/components/svg";
import {useIntl} from "react-intl";
import {AELink} from "../../../_emywork/components/AELink";
import {AERole} from "../../../_emywork/components/AERole";
import {roles} from "../../App";

export function TilesCreateWidget({ className }) {
  const {formatMessage} = useIntl()

  return (
    <>
      <div
        className={`card card-custom bgi-no-repeat bg-gray-900 ${className}`}
        style={{
          backgroundImage: `url("${toAbsoluteUrl("/media/svg/humans/custom-3.svg")}")`,
          backgroundPosition: 'calc(100% + 0.5rem) bottom',
          backgroundSize: 'auto 100%',

        }}
      >
        {/* begin::Body */}
        <div className="card-body d-flex flex-column align-items-start justify-content-start">
          <div className="py-4 flex-grow-1">
            <h3 className="text-white font-weight-bolder line-height-lg mb-5">
              {formatMessage({id:'DASHBOARD.CREATE.TITLE'})}
            </h3>
          </div>
          <AERole
            accept={[roles.client]}
            >
            <AELink
              to={'/emy_projects/new'}
              className="btn btn-link btn-link-white font-weight-bold mt-4"
            >
              {formatMessage({id:'DASHBOARD.CREATE.BUTTON.EMY_PROJECT'})}
              <AESVG
                size={'lg'}
                variant={'white'}
                path={'/Navigation/Arrow-right.svg'}
              />
            </AELink>
          </AERole>
          <AERole
            accept={[roles.provider]}
          >
            <AELink
              to={'/emy_services/new'}
              className="btn btn-link btn-link-white font-weight-bold mt-4"
            >
              {formatMessage({id:'DASHBOARD.CREATE.BUTTON.EMY_SERVICE'})}
              <AESVG
                size={'lg'}
                variant={'white'}
                path={'/Navigation/Arrow-right.svg'}
              />
            </AELink>
          </AERole>

          <AERole
            accept={[roles.provider]}
          >
            <AELink
              to={'/emy_services/new'}
              className="btn btn-link btn-link-white font-weight-bold mt-4"
            >
              {formatMessage({id:'DASHBOARD.CREATE.BUTTON.EMY_PRODUCT'})}
              <AESVG
                size={'lg'}
                variant={'white'}
                path={'/Navigation/Arrow-right.svg'}
              />
            </AELink>
          </AERole>

        </div>
        {/* end::Body */}
      </div>
    </>
  );
}
